<template>
  <div class="borderedBox">
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'BorderedBox',
    props: [],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style>
  .borderedBox {
    padding: 16px;
    border-top: 1px solid #AEAEB2;
    border-bottom: 1px solid #AEAEB2;
  }

</style>
